import * as THREE from 'three';
import type { IPointerController, IPointerHandler } from '@/components/viewPort/PointerController.ts';
import type { SyntheticEvent } from '@/components/viewPort/SyntheticEvent.ts';
import type { IViewPortManager } from '@/engine/app/interfaces.ts';
import type { IIndicationController } from '@/components/boxes/objectBoxes/interfaces.ts';

import addIcon from '@/assets/cursors/addpoint.svg';

const addCur = `url(${addIcon}) 0 24, auto`;

export class PointIndicationPointerHandler implements IPointerHandler {
  private readonly _vpm: IViewPortManager;

  private _indicationController: IIndicationController;

  private _parent?: IPointerController;

  public constructor(vpm: IViewPortManager, indicationController: IIndicationController) {
    this._vpm = vpm;
    this._indicationController = indicationController;
  }

  public setParent(parent: IPointerController): void {
    this._parent = parent;
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-promises -- //TODO: [chebotarev] fix eslint no-misused-promises
  public async onPointerDown(event: SyntheticEvent<PointerEvent>): Promise<void> {
    event.stopPropagation();
    const { offsetX, offsetY } = event.originalEvent;
    if (await this._indicationController.finalizeIndication(this._vpm, new THREE.Vector2(offsetX, offsetY))) {
      this._parent?.setCursor('');
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-promises -- //TODO: [chebotarev] fix eslint no-misused-promises
  public async onPointerMove(event: SyntheticEvent<PointerEvent>): Promise<void> {
    event.preventDefault();
    const { offsetX, offsetY } = event.originalEvent;
    if (await this._indicationController.indicate(this._vpm, new THREE.Vector2(offsetX, offsetY))) {
      this._parent?.setCursor(addCur);
    } else {
      this._parent?.setCursor('');
      return this._indicationController.suspendIndication();
    }
  }

  public onPointerLeave(): void {
    this._parent?.setCursor('');
    this._indicationController.suspendIndication();
  }
}
